import { ComponentsUserWithHoverCard } from "../../../components/User";
import { useUserProfile } from "@repo/query";
import { User as UserType } from "@repo/types";
import { Avatar, cn } from "@heroui/react";
import { User } from "../../../components/User";

export default function ComponentDynamicUser({
    uid,
    blackListed,
    preloadedUser,
}: {
    uid: string;
    /** 命中黑名单时昵称红色高亮 */
    blackListed?: boolean;
    /** 预加载的用户信息（来自批量查询）。提供时跳过单独的 getUserProfile 请求。 */
    preloadedUser?: UserType.UserSearchItem;
}) {
    // 同一 uid 在列表多行 / 详情间共用缓存，不再每行各发一次请求
    const { data: userInfo } = useUserProfile(preloadedUser ? undefined : uid);

    const displayNickname = preloadedUser?.nickname ?? userInfo?.nickname;
    const displayAvatar = preloadedUser?.avatar_url ?? userInfo?.avatar_url;
    const displayUid = preloadedUser?.uid ?? userInfo?.uid;

    return (
        <ComponentsUserWithHoverCard userInfo={userInfo} children={
            <User
                avatar_url={displayAvatar}
                name={<span className={cn("text-sm font-medium text-gray-900 truncate", blackListed ? "text-red-600" : undefined)}>{displayNickname}</span>}
                description={<span className="text-xs text-gray-500">{displayUid}</span>}
            />
        } />
    );
}

export function ComponentDynamicAvatar({ uid }: { uid: string }) {
    const { data: userInfo } = useUserProfile(uid);

    return (
        <ComponentsUserWithHoverCard userInfo={userInfo}>
            <Avatar>
                <Avatar.Image src={userInfo?.avatar_url} />
                <Avatar.Fallback>
                    <div style={{ width: "100%", height: "100%", backgroundColor: "gray" }} />
                </Avatar.Fallback>
            </Avatar>
        </ComponentsUserWithHoverCard>
    )
}
